(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  function initCustomerAddresses() {
    var container = document.querySelector('[data-customer-addresses]');
    if (!container) return;

    // Add address form toggle
    container.querySelectorAll('[data-address-toggle-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = document.getElementById('AddressNewForm');
        var isHidden = form.hidden;
        form.hidden = !isHidden;
        container.querySelectorAll('[data-address-toggle-add]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        });
        if (isHidden) {
          form.querySelector('input').focus();
        }
      });
    });

    // Country/Province selectors
    document.querySelectorAll('[data-address-country-select]').forEach(function (countrySelect) {
      var formContainer = countrySelect.closest('form') || countrySelect.closest('.customer-addresses__form');
      var provinceSelect = formContainer.querySelector('[data-address-province-select]');
      var provinceContainer = provinceSelect ? provinceSelect.closest('.customer-addresses__field') : null;

      var defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) {
        countrySelect.value = defaultCountry;
      }

      updateProvinces(countrySelect, provinceSelect, provinceContainer);

      countrySelect.addEventListener('change', function () {
        updateProvinces(countrySelect, provinceSelect, provinceContainer);
      });
    });

    // Delete buttons
    container.querySelectorAll('[data-address-delete]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        var message = button.getAttribute('data-confirm-message');
        if (!confirm(message)) {
          event.preventDefault();
        }
      });
    });
  }

  function updateProvinces(countrySelect, provinceSelect, provinceContainer) {
    if (!provinceSelect || !provinceContainer) return;

    var selectedOption = countrySelect.options[countrySelect.selectedIndex];
    var provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');

    provinceSelect.innerHTML = '';

    if (provinces.length === 0) {
      provinceContainer.style.display = 'none';
      return;
    }

    provinceContainer.style.display = '';
    provinces.forEach(function (province) {
      var option = document.createElement('option');
      option.value = province[0];
      option.textContent = province[1];
      provinceSelect.appendChild(option);
    });

    var defaultProvince = provinceSelect.getAttribute('data-default');
    if (defaultProvince) {
      provinceSelect.value = defaultProvince;
    }
  }

  initCustomerAddresses();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  function initCustomerLogin() {
    var recoverForm = document.getElementById('RecoverForm');
    var loginForm = document.getElementById('LoginForm');
    var recoverLink = document.getElementById('RecoverLink');
    var cancelRecover = document.getElementById('CancelRecover');

    if (!recoverForm || !loginForm) return;

    function showRecoverForm() {
      recoverForm.style.display = '';
      loginForm.style.display = 'none';
      window.location.hash = '#recover';
    }

    function showLoginForm() {
      recoverForm.style.display = 'none';
      loginForm.style.display = '';
      window.location.hash = '';
    }

    if (recoverLink) {
      recoverLink.addEventListener('click', function (event) {
        event.preventDefault();
        showRecoverForm();
      });
    }

    if (cancelRecover) {
      cancelRecover.addEventListener('click', function (event) {
        event.preventDefault();
        showLoginForm();
      });
    }

    if (window.location.hash === '#recover') {
      showRecoverForm();
    }
  }

  initCustomerLogin();

  } catch(e) { console.error(e); }
})();
})();
